import React from 'react';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gold text-darktext font-bold py-2 overflow-hidden whitespace-nowrap flex items-center shadow-md" data-id="element-201">
      <div className="animate-marquee flex gap-8 w-[200%]" data-id="element-202">
        {[...Array(20)].map((_, i) => <span key={i} className="text-sm tracking-wider" data-id="element-203">
            🔥 SOLO POR HOY + 6 EBOOKS GRATIS 🔥
          </span>)}
      </div>
    </div>;
}